import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { VideoFactory } from "../../factories/VideoFactory"
import { EditorComponentContract } from '../EditorComponentContract'

export class Video extends EditorComponentContract {
  constructor() {
    super(Variations);
    this.htmlBuilder = HtmlBuilder
    this.factory = new VideoFactory
  }

  info() {
    return {
      name: 'Video',
      icon: 'fa-video',
      variations: this.variationsInfo()
    }
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes', 'containerClasses']
  }

  elementContents() {
    return []
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }
}
